import { z } from "zod";

const zEntityNameSchema = z.enum(["ORDER", "INQUIRY", "NOTIFICATION", "REVIEW", "UNKNOWN"]);
const EntityNameSchema = zEntityNameSchema.Enum;
type EntityNameSchema = z.infer<typeof zEntityNameSchema>;

export { EntityNameSchema as EntityName, EntityNameSchema, zEntityNameSchema };
